import { Fragment } from "react";
import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { MemberProfileACPSectionSkeleton } from "@/components/Provider/PatientView/MemberProfile/MemberProfileACPSection/MemberProfileACPSectionSkeleton";

const SKELETON_HEIGHT = 15;

function MemberProfilePolicyList() {
  return (
    <DashboardCard2 title={<Skeleton height={SKELETON_HEIGHT} width={185} />}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Fragment key={`member-profile-policy-list-skeleton-${index}`}>
          <div className="tw:grid tw:grid-cols-4 tw:gap-3 tw:border-b tw:border-stroke-quaternary tw:p-2.5">
            <Skeleton height={SKELETON_HEIGHT} width={96} />
            <Skeleton height={SKELETON_HEIGHT} width={107} />
            <Skeleton height={SKELETON_HEIGHT} width={136} />
            <Skeleton height={SKELETON_HEIGHT} width={96} />
          </div>

          <div className="tw:grid tw:grid-cols-4 tw:gap-3 tw:border-b tw:border-stroke-quaternary tw:p-2.5">
            <Skeleton height={SKELETON_HEIGHT} width={208} />
            <Skeleton height={SKELETON_HEIGHT} width={82} />
            <Skeleton height={SKELETON_HEIGHT} width={118} />
            <Skeleton height={SKELETON_HEIGHT} width={145} />
          </div>
        </Fragment>
      ))}
    </DashboardCard2>
  );
}

export function MemberProfileConsentsSectionSkeleton() {
  return (
    <>
      <MemberProfileACPSectionSkeleton />
      <MemberProfilePolicyList />
    </>
  );
}
